module.exports = __webpack_public_path__ + "assets/img/3.518d1abd.png";